//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VuxUpload from '@/components/upload'
import { mapActions } from 'vuex'
export default {
  name: 'upload',
  props: [],
  components: {
    VuxUpload
  },
  data () {
    return {
      upload: {
        data: {
          id: 1
        },
        images: [],
        max: 3,
        maxSize: 2048000,
        accept: 'image/png, image/jpeg, image/gif, image/jpg, image/bmp',
        capture: ''
      },
      files: [],
      addressFile: {
        iles: [],
        filesData: []
      }
    }
  },
  computed: {},
  created () {
  },
  mounted () {
    this.files = this.$store.state.addressFile.files
    this.upload.images = this.$store.state.addressFile.filesData
  },
  methods: {
    ...mapActions(['addressFileAction']),
    onSuccess (file, data) {
      this.upload.images.push({
        src: data[0]
      })
      this.files.push(file)
      this.addressFile = {
        filesData: this.upload.images,
        files: this.files
      }
      this.$store.dispatch('addressFileAction', this.addressFile)
    },
    onError (e) {
      console.log(e.message)
    },
    onRemove (index) {
      this.upload.images.splice(index, 1)
      this.files.splice(index, 1)
      this.addressFile = {
        filesData: this.upload.images,
        files: this.files
      }
      this.$store.dispatch('addressFileAction', this.addressFile)
    }
  }
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/address/upload.vue